import { FILE_ATTACHMENTS_CONSTANTS } from "../../../constants";
import { FormValidationType } from "../../../../types";

export const formFieldsValidation: FormValidationType = {
  [FILE_ATTACHMENTS_CONSTANTS.COMMERCIAL_INVOICE]: {
    required: { value: true },
  },
  [FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_FRONT]: {
    required: { value: true },
  },
  [FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_REVERSE]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.PACKING_SLIP]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.DAMAGED_PACKAGING_PHOTOS]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.DAMAGED_CONTENTS_PHOTOS]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.PROOF_OF_DELIVERY]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.PROOF_FROM_CARRIER]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.POLICE_REPORT]: {
    required: { value: false },
  },
  [FILE_ATTACHMENTS_CONSTANTS.ADDITIONAL_DOCUMENTS]: {
    required: { value: false },
  },
};
